// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__33IND","footer":"ModalError_footer__396lL"};